import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    inputText: {
      margin: '5px 10px!important',
      padding: '5px 0 5px 30px!important',
      width: '100%',
      fontSize: 11,
      height: '45px!important',
      backgroundColor: '#ffffff',
    },
    iconSearch: {
      marginLeft: 20,
      position: 'absolute',
      width: 15,
      height: 15,
    },
    gridIconFilter: {
      backgroundColor: '#a51713',
      width: 40,
      borderRadius: 10,
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      height: 40,
    },
  }),
);

export default useStyles;
